type EnvKey = 'VITE_API_URL';

declare global {
  interface Window {
    __ENV__?: Partial<Record<EnvKey, string>>;
  }
}

function read(key: EnvKey): string | undefined {
  const runtime = window.__ENV__?.[key];
  if (runtime && !runtime.startsWith('__')) return runtime;
  return import.meta.env[key];
}

export function getEnv(key: EnvKey): string {
  const value = read(key);
  if (!value) throw new Error(`${key} is required`);
  return value;
}

export function getOptionalEnv(key: EnvKey): string | undefined {
  return read(key);
}
